import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Set } from 'immutable';
import DiagnosticToolItem from './DiagnosticToolItem';

const DiagnosticTools = ({
  tab,
  tools,
  units,
  products,
  onAdd,
  onUpdate,
  onDelete,
}) => {
  const addTool = evt => {
    evt.preventDefault();
    onAdd(tab);
    return false;
  };

  const updateTool = (tool, values) => onUpdate(tab, tool, values);
  const deleteTool = tool => onDelete(tab, tool);

  return (
    <div>
      <h5>Description du matériel</h5>
      <table className="ui table">
        <thead>
          <tr>
            <th className="one wide">
              <button className="ui icon button" onClick={addTool}>
                <i className="icon add" />
              </button>
            </th>
            <th className="eleven wide">Produit</th>
            <th className="four wide">Quantité</th>
          </tr>
        </thead>
        <tbody>
          {tools.map(t => (
            <DiagnosticToolItem
              key={t.id}
              tool={t}
              units={units}
              products={products}
              onChange={updateTool}
              onDelete={deleteTool}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
};

DiagnosticTools.propTypes = {
  tab: PropTypes.string.isRequired,
  tools: ImmutablePropTypes.set,
  units: PropTypes.array.isRequired,
  products: ImmutablePropTypes.set,
  onAdd: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

DiagnosticTools.defaultProps = {
  tools: Set(),
  products: Set(),
};

export default DiagnosticTools;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/components/DiagnosticTools.js